import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from '@env';
import { ErrorHandlerService } from './response-utils.service';
import { catchError } from 'rxjs';
import { Integration } from '@components/integration';

@Injectable({ providedIn: 'root' })
export class IntegrationService {
  private readonly integrationController: string = environment.apiUrl + '/cad/integration';

  private readonly cadAuthController: string = environment.apiUrl + '/cad/auth-type';

  private readonly objectStrategyController: string = environment.apiUrl + '/cad/object-strategy';

  private http = inject(HttpClient);
  private errorHandler = inject(ErrorHandlerService);

  saveIntegration(integration: Integration) {
    return this.http
      .post(this.integrationController, integration)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  updateIntegration(integration: Integration) {
    const url = `${this.integrationController}/${integration.id}`;
    return this.http
      .put(url, integration)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getIntegrationById(id: string) {
    return this.http
      .get(`${this.integrationController}/${id}`)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getIntegrationList(integrationCategory: string) {
    const params = new HttpParams().set('integration-category', integrationCategory);
    return this.http
      .get(this.integrationController, { params })
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  isValueUnique(type: string, value: string) {
    return this.http
      .get(`${this.integrationController}/unique/${type}/${value}`)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getAuthTypes() {
    return this.http
      .get(this.cadAuthController)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  getObjectStrategies(type: string) {
    const params = new HttpParams().set('integration-type', type);
    return this.http
      .get(this.objectStrategyController, { params })
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }
}
